import { ChangeDetectionStrategy, Component } from '@angular/core';
import { V2Flex } from '../helpers/v2-flex.extendable';

@Component({
  selector: 'v2-column',
  template: ` <ng-content></ng-content> `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class V2Column extends V2Flex {}
